var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"api-key":"zaw1vim746a6hngmrlxlworj9cswkanxln3b2abe4xheyfw5","init":_vm.editorInit,"placeholder":_vm.phVal},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})}
var staticRenderFns = []

export { render, staticRenderFns }